import React from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from 'antd';

type SupportedLocale = 'en' | 'zh-CN' | 'zh-HK';

function normalizeLanguage(lang: string): SupportedLocale {
  if (lang && lang.startsWith('en')) return 'en';
  if (lang === 'zh-TW' || lang === 'zh-HK') return 'zh-HK';
  if (lang === 'zh-CN') return 'zh-CN';
  return 'zh-CN';
}

const LocaleSelector: React.FunctionComponent = () => {
  const { i18n } = useTranslation();
  const { Option } = Select;

  function handleLanguageChange(value: SupportedLocale): void {
    i18n.changeLanguage(value);
  }

  return (
    <>
      <Select onChange={handleLanguageChange} style={{ width: '100%' }} value={normalizeLanguage(i18n.language)}>
        <Option value={'en'}>English</Option>
        <Option value={'zh-CN'}>简体中文</Option>
        <Option value={'zh-HK'}>繁體中文</Option>
      </Select>
    </>
  );
};

export default LocaleSelector;
